export interface MultiEntitySelectionReportParameter {
   accountId?: number | null;
   all?: boolean;
   values: number[];
}

export interface SortedMultiEntitySelectionReportParameter {
   all?: boolean;
   values: { id: number; sortOrder?: number }[];
}

export interface NullableMultiEntitySelectionReportParameter extends MultiEntitySelectionReportParameter {
   includeNull?: boolean;
}

export const defaultAllMultiEntitySelectParameter: NullableMultiEntitySelectionReportParameter = {
   all: true,
   includeNull: false,
   values: [],
};
export const defaultNoneMultiEntitySelectParameter: NullableMultiEntitySelectionReportParameter = {
   all: false,
   includeNull: false,
   values: [],
};
